/*
 * 登陆组件验证
 *
 * @requires lib.storage
 * @author 景烁
 */
(function (win, lib) {
  const helper = {
    // 类似 http://localhost:8080/#/pages/login?redirectUrl=http%3A%2F%2Flocalhost%3A8080%2F%23%2Feshow%2Fproduct%2F2%2Fsetting
    getParamsFromUrl() {
      const query_string = {};
      const locationUrl = location.href;
      const query = locationUrl.indexOf('?') > -1 && locationUrl.split('?')[1] || null;

      if (!query) {
        return {};
      }

      const vars = query.split('&');
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');

        // If first entry with this name
        if (typeof query_string[pair[0]] === 'undefined') {
          query_string[pair[0]] = pair[1];
          // If second entry with this name
        } else if (typeof query_string[pair[0]] === 'string') {
          const arr = [query_string[pair[0]], pair[1]];
          query_string[pair[0]] = arr;
          // If third or later entry with this name
        } else {
          query_string[pair[0]].push(pair[1]);
        }
      }
      return query_string;
    },
  };

  lib.login = {
    // 判断是否登陆
    isLogin() {
      return !!lib.cookie.get('yytools_token');
    },

    // 跳转登陆页
    goLogin(redirectUrl, logout) {
      redirectUrl = redirectUrl || location.href;
      lib.cookie.set('yytools_token', '');

      // todo 替换掉形式
      location.href = `/pages/login?redirectUrl=${encodeURIComponent(redirectUrl)}`;
    },

    // 登出
    logout(redirectUrl) {
      redirectUrl = redirectUrl || '';
      lib.cookie.rm('yytools_token');
      const that = this;
      setTimeout(() => {
        that.goLogin(redirectUrl, true);
      }, 100);
    },
    //跳转首页
    gotoHome() {
      const params = helper.getParamsFromUrl();
      if (params.redirectUrl) {
        redirectUrl = decodeURIComponent(params.redirectUrl);
      } else {
        redirectUrl = '/';
      }
      location.replace(redirectUrl);
    },
    
    // 登陆后写入数据
    new_login(logData) {
      if (!logData || !logData.access_token) {
        return;
      }
      lib.storage.set('user', logData.data.user);
      lib.login.setAppKeyAppPwd(logData.data.user.app_key, logData.data.user.app_pwd);

      // 删除缓存的边栏设置
      lib.storage.rm('moduleList');
    },

    //登录完成后的跳转方法
    new_replace(redirectUrl) {
      // 最后跳首页
      if (!redirectUrl) {
        const params = helper.getParamsFromUrl();
        if (params.redirectUrl) {
          redirectUrl = decodeURIComponent(params.redirectUrl);
        } else {
          redirectUrl = '/';
        }
      }
      location.replace(redirectUrl);
    },



    // 登陆后写入数据
    login(logData, redirectUrl) {
      if (!logData || !logData.accessToken) {
        return;
      }
      // 最后跳首页
      if (!redirectUrl) {
        const params = helper.getParamsFromUrl();
        if (params.redirectUrl && decodeURIComponent(params.redirectUrl).indexOf('/pages/login') === -1) {
          redirectUrl = decodeURIComponent(params.redirectUrl);
        } else {
          redirectUrl = '/';
        }
      }
      if(location.href.includes('8085')){
        lib.cookie.set('yytools_token',logData.accessToken);
        lib.cookie.set('mobile',logData.phoneNumber);
        lib.cookie.set('yytools_tags',logData.tags || '');
        lib.cookie.set('authority',logData.authority || '');
      }else{
        lib.cookie.set('yytools_token',logData.accessToken, '', '', '.mockuai.com');
        lib.cookie.set('mobile',logData.phoneNumber, '', '', '.mockuai.com');
        lib.cookie.set('yytools_tags',logData.tags || '', '', '', '.mockuai.com');
        lib.cookie.set('authority',logData.authority || '', '', '', '.mockuai.com');
      }
      lib.storage.set('user', logData);
      // 删除缓存的边栏设置
      lib.storage.rm('moduleList');

      location.replace(redirectUrl);
    },

    setAppKeyAppPwd(appKey, appPwd) {
      localStorage.setItem('app_key', appKey);
      localStorage.setItem('app_pwd', appPwd);
      lib.api.app_key = appKey;
      lib.api.app_pwd = appPwd;
    },

    // 获取账号昵称
    getUserName() {
      return lib.storage.get('userName');
    },

    // 根据ID跳转到对应的登陆页面
    redirect(groupIdList, hostList) {
      let list = hostList[process.env.__ENV__],
        url = '';
      groupIdList.forEach(function (id) {
        list.forEach(function (item) {
          if (item.groupList.indexOf(id) !== -1) {
            url = item.host;
            return;
          }
        });
      });
      lib.storage.rm('group_id_list');
      if (url) {
        location.href = url;
      } else {
        location.href = '/pages/login';
      }
    },
    // 检查登陆返回的group_id
    checkGroupId(groupIdList, currentGroupIdList) {
      let result = false;
      currentGroupIdList.forEach(function (currentId) {
        groupIdList.forEach(function (id) {
          if (currentId === id) {
            result = true;
          }
        });
      });
      return result;
    }
  };
}(window, window.lib || (window.lib = {})));
